import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import QueueListSvg from '@/assets/QueueList.svg';

const QueueList = ({ size, variant, className }: IconProps) => (
  <img
    src={QueueListSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default QueueList;
